var map = {
	"./aqualantis.jpg": 8351,
	"./candy-fizz-info.jpg": 7735,
	"./candy-fizz.jpg": 1448,
	"./dango-bar-info.jpg": 2261,
	"./dango-bar.jpg": 4217,
	"./fruits-win-fall.jpg": 8607,
	"./happy-hops.jpg": 5448,
	"./lucky-fruity-info.jpg": 8478,
	"./lucky-fruity.jpg": 5371,
	"./night-rush.jpg": 1548,
	"./sesame-vault.jpg": 1902,
	"./sweet-box-info.jpg": 2500,
	"./sweet-box.jpg": 8455,
	"./tomas-coins.jpg": 7487,
	"./toxic-alice.jpg": 1037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;